<template>
  <div id="app">

    <ion-app>
      <ion-menu content-id="main-content">
        <ion-header>
          <ion-toolbar color="red">
            <ion-title>Menu</ion-title>
          </ion-toolbar>
        </ion-header>

        <ion-content>
          <ion-list>
            <ion-menu-toggle auto-hide="false">
              <ion-item href="/#/" style="padding-left: 0">
                <ion-icon name="home"></ion-icon>
                <ion-label>
                  Dashboard
                </ion-label>
              </ion-item>
              <ion-item href="/#/config/list" style="padding-left: 0">
                <ion-icon name="apps"></ion-icon>
                <ion-label>
                  Einstellungen
                </ion-label>
              </ion-item>

              <ion-item href="/#/tag/list/">
                <ion-icon name="bookmarks"></ion-icon>
                <ion-label>
                  Tags
                </ion-label>
              </ion-item>
              <ion-item href="/#/search/">
                <ion-icon name="search"></ion-icon>
                <ion-label>
                  Suche
                </ion-label>
              </ion-item>
              <ion-item href="/#/content/new/">
                <ion-icon name="images"></ion-icon>
                <ion-label>
                  Inhalt erstellen
                </ion-label>
              </ion-item>
              <ion-item href="/#/box/list/">
                <ion-icon name="browsers"></ion-icon>
                <ion-label>
                  Boxen und Tabs
                </ion-label>
              </ion-item>
              <ion-item href="/#/export">
                <ion-icon name="save"></ion-icon>
                <ion-label>
                  Export/Import
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>
        </ion-content>
      </ion-menu>

      <ion-page class="ion-page" id="main-content">
        <ion-header>

          <ion-toolbar color="red">

            <ion-buttons slot="start">
              <ion-menu-toggle>
                <ion-button>
                  <ion-icon slot="icon-only" name="menu"></ion-icon>
                </ion-button>
              </ion-menu-toggle>
            </ion-buttons>
            <ion-buttons slot="end">
              <ion-title>
                Mein Wissen v0.6
              </ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
              <ion-button  href="/#/search/">
                <ion-icon name="search"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title>
              <a  href="/#/" class="home">
                <ion-icon name="home"></ion-icon>
              </a>
            </ion-title>

            <Message/>
          </ion-toolbar>

        </ion-header>
        <ion-content>
          <ion-vue-router/>
        </ion-content>
      </ion-page>
    </ion-app>

    <ion-menu-controller></ion-menu-controller>


  </div>
</template>

<script>
  import Message from "./components/Message";

  export default {
    name: "App",
    components: {
      Message
    },
  };

</script>

<style lang="scss">
  @import './../scss/general.scss';
  @import './../scss/general-display.scss';
  @import './../scss/ion-button.scss';
  @import './../scss/ion-card.scss';
  @import './../scss/ion-content.scss';
  @import './../scss/ion-grid.scss';
  @import './../scss/ion-icon.scss';
  @import './../scss/ion-item.scss';
  @import './../scss/ion-label.scss';
  @import './../scss/ion-list.scss';
  @import './../scss/ion-menu.scss';
  @import './../scss/ion-router-outlet.scss';
  @import './../scss/ion-searchbar.scss';
  @import './../scss/text.scss';
  @import './../scss/overflow.scss';
  @import './../scss/popover.scss';
  @import './../scss/slider.scss';
  @import './../scss/form.scss';

  .inner-scroll {
    background-color: #2E2D2D !important;
  }

  .label-stacked {
    min-height: 28px;
  }

  .images  img {
    height: 70px;
    width: auto;
    margin-right: 30px;
  }

  .toolbar-container {
    background-color: red !important;
  }

  .link-button {
    text-transform: uppercase;
    margin-top: 40px;
    display: inline-block;
  }

  .vue-popover {
    margin-top: -57px !important;
  }

  .more-icon {
    width: 100%;
    display: flex;
    justify-content: right;
    flex-direction: row-reverse;
  }

  .home {
    font-size: 25px;
  }

  .page-content .sc-ion-searchbar-md-h{
    padding: 0 !important;
  }

  .page-content .col-input-tag {
    padding: 0;
    --padding: 0;
  }

  .ion-padding {
    background-color: #2E2D2D;

    @media (min-device-width: 800px) {
      padding: 30px;
    }
  }

  .toolbar-background, ion-toolbar, .toolbar-container {
    background-color: #2E2D2D !important;
    border-bottom: 0;
  }

  .item-native {
    padding-left: 0 !important;
  }

  .view-container {
    margin: 10px 50px 50px 50px;
  }

  .router-link-exact-active {
    color: rgba(0, 0, 0, 0.7) !important;
  }

</style>
